import client from "../libs/HttpClient";

class AdminAuthService {
  static login(loginData) {
    return client.post("/login", loginData);
  }
}

export { AdminAuthService };
